import { Modal } from '@mui/material';
import {
  Add,
  Assignment,
  Close,
  Delete,
  Edit,
  VisibilityOffRounded,
  VisibilityRounded,
} from '@mui/icons-material';
import React, { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useRubrices } from "store/rubric/selectors";
import {
  handleDeleteRubric,
  handleEditRubric,
  handleGetRubric,
} from "store/rubric/thunks";
import styled from "styled-components";
import ModalMenu from "..";
import Loading from "components/Loading";
import COLOR from "utils/constants/color";
import { Tooltip } from "antd";
import { useCurrentUser } from "store/users/selectors";
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';

const MENU = [
  { id: "owe_created", value: "OneWay Created" },
  { id: "my_created", value: "My Rubrics" },
  { id: "archived_rubric", value: "Archived Rubrics" },
];

const ListRubricModal = ({ open, close }) => {
  const currentUser = useCurrentUser();
  const [dataTab, setDataTab] = useState("owe_created");
  const [openPreviewRubricModal, setOpenPreviewRubricModal] = useState(false);
  const [previewRubric, setPreviewRubric] = useState({});
  const [loader, setIsLoader] = useState(false);
  const [editRubric, setEditRubric] = useState({});
  const dispatch = useDispatch();
  const [selectedIndex, setSelectedIndex] = useState([]);
  const [openCreateRubricModal, setOpenCreateRubricModal] = useState(false);
  const [openArchivedConfirmation, setOpenArchivedConfirmation] =
    useState(false);
  const [deleteConfirmation, setDeleteConfirmation] =
    useState(false);
  const [hideUnhideRubricId, setHideUnhideRubricId] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const rubricData = useRubrices() || [];
  const [loaderForHide, setLoaderHide] = useState(false);
  const showAlert = useAlert();

  const editHandler = (data) => {
    if (loader) {
      return;
    }
    setEditRubric(data);
    setOpenCreateRubricModal(true);
  };

  const deleteHandler = async () => {
    setIsLoader(true);
    await dispatch(handleDeleteRubric(deleteId));
    setIsLoader(false);
    setDeleteId("")
  };

  const openArchivedConfirmationModal = (id) => {
    setOpenArchivedConfirmation(true);
    setHideUnhideRubricId(id);
  };

  const openDeleteConfirmation = (id) => {
    setDeleteConfirmation(true);
    setDeleteId(id);
  };

  function navigationToMenu(id) {
    setDataTab(id);
  }

  const closeHandler = () => {
    close();
    setDataTab("owe_created");
  };

  const handlerHideRubric = async () => {
    setLoaderHide(true);
    const rubric =
      rubricData?.find((element) => element?.id === hideUnhideRubricId) || {};
    const payload = { ...rubric, is_hide: !rubric?.is_hide };
    await dispatch(handleEditRubric(payload));
    await dispatch(handleGetRubric(currentUser?.id));
    setLoaderHide(false);
  };

  return (
    <>
      <ModalMenu
        type="createRubricModal"
        open={openCreateRubricModal}
        close={(data,getRubricData,is_clone_rubric) => {
          setOpenCreateRubricModal(false);
          if(is_clone_rubric){
            showAlert("Rubric cloned successfully.. Please check your rubrics", "success");
            navigationToMenu("my_created");
          }
        }}
        editRubric={editRubric}
        setEditRubric={setEditRubric}
      />
      <ModalMenu
        type="previewRubricModal"
        open={openPreviewRubricModal}
        close={() => {
          setOpenPreviewRubricModal(false);
        }}
        rubrics_meta={previewRubric?.rubrics_meta || []}
        mainTitle={previewRubric?.title || ""}
      />
      <ModalMenu
        type="closeConfirmationModal"
        open={openArchivedConfirmation}
        close={() => {
          setOpenArchivedConfirmation(false);
          setHideUnhideRubricId("");
        }}
        messageTitle={
          dataTab === MENU[2].id
            ? `Are you sure you want to display this rubric?`
            : "Are you sure you want to hide this rubric?"
        }
        actionOnOk={() => handlerHideRubric()}
        isLoading={loaderForHide}
      />
      <ModalMenu
        type="closeConfirmationModal"
        open={deleteConfirmation}
        close={() => {
          setDeleteConfirmation(false);
        }}
        messageTitle={"Are you sure you want delete this rubric"}
        actionOnOk={() => deleteHandler()}
        isLoading={loader}
      />
      <Modal open={open} onClose={closeHandler} className="modal-for-rubric">
        <ModalContent orientation={window.screen.orientation}>
          <CloseButton onClick={closeHandler}>
            <Close />
          </CloseButton>
          <div className="w-full">
            <div className="heading-label mb-30px">Rubrics</div>
            <MenuWrapper top={"10px"} style={{ width: "100%" }}>
              {MENU.map((x) => {
                return (
                  <MenuBtn
                    style={{
                      borderBottom:
                        dataTab === x?.id
                          ? "5px solid rgb(28,49,115)"
                          : "5px solid lightGrey",
                      color: dataTab === x?.id ? "rgb(28,49,115)" : "black",
                    }}
                    key={x.id}
                    onClick={() => navigationToMenu(x.id)}
                  >
                    {x.value}
                  </MenuBtn>
                );
              })}
            </MenuWrapper>
            <RubricButton
              type="primary"
              className="flex items-center justify-center"
              onClick={() => setOpenCreateRubricModal(true)}
              style={{
                marginRight: 30,
                marginTop: -9,
                float: "right",
                boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
                transition: "all 0.3s ease-in-out",
                ":hover": {
                  transform: "scale(1.05)",
                  boxShadow: "0px 0px 15px rgba(0,0,0,0.3)",
                },
              }}
            >
              <Add className="text-black-10" style={{ marginRight: "2px" }} />
              Add Rubric
            </RubricButton>
          </div>

          <div className="w-full flex flex-col gap-10px mt-16px overflow-auto px-10px py-10px">
            {dataTab == MENU[0].id && (
              <RubricsCreated
                rubricData={rubricData}
                selectedIndex={selectedIndex}
                setSelectedIndex={setSelectedIndex}
                dataTab={dataTab}
                loader={loader}
                deleteHandler={openDeleteConfirmation}
                setOpenPreviewRubricModal={setOpenPreviewRubricModal}
                editHandler={editHandler}
                setPreviewRubric={setPreviewRubric}
                openArchivedConfirmation={openArchivedConfirmationModal}
              />
            )}

            {dataTab == MENU[1].id && (
              <RubricsCreated
                rubricData={rubricData}
                selectedIndex={selectedIndex}
                setSelectedIndex={setSelectedIndex}
                dataTab={dataTab}
                loader={loader}
                deleteHandler={openDeleteConfirmation}
                setOpenPreviewRubricModal={setOpenPreviewRubricModal}
                editHandler={editHandler}
                setPreviewRubric={setPreviewRubric}
                openArchivedConfirmation={openArchivedConfirmationModal}
              />
            )}

            {dataTab == MENU[2].id && (
              <RubricsCreated
                rubricData={rubricData}
                selectedIndex={selectedIndex}
                setSelectedIndex={setSelectedIndex}
                dataTab={dataTab}
                loader={loader}
                deleteHandler={openDeleteConfirmation}
                setOpenPreviewRubricModal={setOpenPreviewRubricModal}
                editHandler={editHandler}
                setPreviewRubric={setPreviewRubric}
                openArchivedConfirmation={openArchivedConfirmationModal}
                mode={"archived"}
              />
            )}
          </div>
        </ModalContent>
      </Modal>
    </>
  );
};

const RubricsCreated = ({
  rubricData,
  selectedIndex,
  setSelectedIndex,
  dataTab,
  loader,
  deleteHandler,
  setOpenPreviewRubricModal,
  editHandler,
  setPreviewRubric,
  openArchivedConfirmation,
  mode = "",
  is_placement
}) => {
  const all_rubrics_data = useMemo(() => rubricData.filter((rubric) => is_placement ? rubric.is_placement : !rubric.is_placement), [rubricData]);
  let filterRubrics;
  if (mode === "archived") {
    filterRubrics = all_rubrics_data?.filter(
      (element) => element?.is_hide && element?.created_by === "teacher"
    ) || [];
  } else {
    filterRubrics = all_rubrics_data?.filter((rubric) =>
      dataTab === "my_created"
        ? (rubric?.created_by === "teacher" && rubric?.is_hide === false)  || rubric?.is_hide === null
        : rubric?.created_by === "owe_admin" && rubric?.is_hide === false
    ) || [];
  }

  const isAdmin = dataTab === "owe_created";
  return (
    <>
      {filterRubrics?.length === 0 && (
        <div className="bubbleNotesNoData text-blue-10">No data available</div>
      )}
      <div className="w-full flex flex-col gap-10px mt-16px overflow-auto px-10px py-10px">
        {filterRubrics &&
          filterRubrics?.length > 0 &&
          filterRubrics?.map((data, critesionIndex) => {
            const isAssigned =
              data?.total_assigned && Number(data?.total_assigned) > 0;
            return (
              <RubricContainerDiv
                key={critesionIndex}
                style={{
                  opacity: loader && selectedIndex === critesionIndex && "0.7",
                }}
                className="flex flex-col items-center"
                onClick={() => setSelectedIndex(critesionIndex)}
                loader={loader}
              >
                <RubricSubContainerDiv className="flex items-center justify-between w-full">
                  {loader && selectedIndex === critesionIndex && (
                    <Loading white={false} size={20} />
                  )}
                 <div
                    onClick={(e) => {
                      e.stopPropagation();
                    //  setPreviewRubric(data);
                      //setOpenPreviewRubricModal(true);
                    }}
                    className={`${
                      !isAdmin && "rubricData-title-width"
                    } rubricData-title w-full text-start flex items-center`}
                  >
                    <Assignment className="mr-10px" />
                    <Tooltip
                      placement="top"
                      title={data?.title?.length > 25 ? data?.title : ""}
                      overlayClassName="custom-tooltip"
                      getPopupContainer={(trigger) => trigger.parentNode}
                    >
                      <span className="text-wrap my_rubric_width" >
                        {
                          data.title
                        }
                      </span>
                    </Tooltip>
                  </div>
                  <div className="flex items-center" style={{ gap: 8 }} onClick={(e) => e.stopPropagation()}>
                    <PreviewEditBtn
                      type="button"
                      onClick={() => {
                        setPreviewRubric(data);
                        setOpenPreviewRubricModal(true);
                      }}
                    >
                      Preview
                    </PreviewEditBtn>
                    <PreviewEditBtn
                      type="button"
                      $variant="edit"
                      onClick={() => editHandler(data)}
                    >
                      Edit
                    </PreviewEditBtn>
                  {!isAdmin && (
                    <>
                      <Button
                        style={{
                          cursor:
                            (loader && selectedIndex === critesionIndex) ||
                            (isAssigned && "default"),
                          opacity:
                            (loader && selectedIndex === critesionIndex) ||
                            (isAssigned && "0.4"),
                            height: "24px",
                        }}
                        disabled={
                          (loader && selectedIndex === critesionIndex) ||
                          isAssigned
                        }
                        onClick={() => deleteHandler(data?.id)}
                      >
                        {/* <span className="text-red-10">Delete</span> */}
                        <Delete
                          className="cursor-pointer text-red-10"
                          style={{
                            fontSize: 20,
                            transition: "all 0.3s ease-in-out",
                          }}
                        />
                      </Button>

                      <Button
                        style={{
                          height: "24px",
                        }}
                        onClick={() => openArchivedConfirmation(data?.id)}
                      >
                        {mode === "archived" ? (
                          <VisibilityOffRounded
                            style={{
                              fontSize: 20,
                              transition: "all 0.3s ease-in-out",
                            }}
                            className="cursor-pointer text-blue-10"
                          />
                        ) : (
                          <VisibilityRounded
                            style={{
                              fontSize: 20,
                              transition: "all 0.3s ease-in-out",
                            }}
                            className="cursor-pointer text-blue-10"
                          />
                        )}
                      </Button>
                    </>
                  )}
                  </div>
                </RubricSubContainerDiv>
              </RubricContainerDiv>
            );
          })}
      </div>
    </>
  );
};

const MenuWrapper = styled.div`
  display: flex;
  flex-direction: row;
  //   justify-content: space-between;
  width: 100%;
  min-height: 50px;
  border-radius: 12px;
  //   border: 2px solid ${COLOR.black100};
  //   background-color: ${COLOR.blueish400};
  margin-top: ${(p) => (p.top ? p.top : "50px")};
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 2px 0px;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;

const MenuBtn = styled.button`
  background-color: white;
  border-top: none;
  border-left: none;
  border-right: none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  outline: none;
  transition: all 300ms ease;
  padding: 2px 16px 10px 16px;
  min-width: 150px;
  margin-right: 2px;
  margin-left: 2px;
  @media (max-width: 992px) {
    margin-top: 10px;
  }
`;

const Button = styled.button`
  background: none;
  border: none;
  outline: none;
  padding: none;
`;

const PreviewEditBtn = styled.button`
  border: 1px solid #dadce0;
  color: ${(p) => (p.$variant === 'edit' ? '#1b5e20' : '#1a73e8')};
  min-width: 60px;
  height: 32px;
  border-radius: 6px;
  outline: none;
  padding: 4px 8px;
  background: transparent;
  cursor: pointer;
  font-size: 12px;
`;

const RubricSubContainerDiv = styled.div`
  padding-inline: 20px;
  padding-top: 4px;
  padding-bottom: 4px;
`;

const RubricContainerDiv = styled.div`
  justify-content: space-between;
  border: 1px solid darkgrey;

  border-radius: 12px;
  align-items: center;

  boxShadow: 0px 0px 10px rgba(0,0,0,0.2);
  transition: all 0.3s ease-in-out;
`;

const RubricButton = styled.button`
  width: 115px;
  height: 34px;

  background-image: linear-gradient(
    to right,
    rgb(3, 152, 158),
    rgb(67, 150, 156)
  );
  color: white;
  border: none;
  border-radius: 6px;
  float: right;
  margin-right: 30px;
  margin-top: -9px;
  cursor: pointer;

  @media (max-width: 600px) {
    margin-right: 46px !important;
    margin-top: 5px !important;
  }
`;

const ModalContent = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  position: relative;
  width: ${(props) => (props.orientation === "landscape" ? "90%" : "100%")};
  height: ${(props) => (props.orientation === "landscape" ? "80%" : "100%")};
  max-width: 47.5rem;
  padding: 1.5rem 1.5rem;
  max-height: 600px;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media (max-width: 425px) {
    padding: 5px;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgb(204, 80, 71);
  color: white;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1;
`;

export default ListRubricModal;
